/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: choice-Widget - Mehrfachauswahl mit zwei Listen
 *
 * Das choice-Widget bietet die Möglichkeit einen oder mehrere Werte auszuwählen.
 * Die Werte die zur Auswahl stehen werden in der rechten Liste angezeigt.
 * Werte die bereits ausgewählt wurden, werden in der linken Liste angezeigt.
 * Wird ein Wert ausgewählt, dann wird er aus der rechten Liste entfernt.
 * Ein Doppelklick in der rechten Liste fügt den Wert zur Auswahl hinzu.
 * Ein Doppelklick in der linken Liste entfernt den Wert aus der Auswahl.
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "fields": [
    {
        "id": "client",
        "length": 80,
        "label": "Client",
        "unitLabel": "",
        "description": "Client",
        "placeholder": "",
        "widget": "choice",
        "maxItems": 3,
        "visibleItems": 4,
        "group": null,
        "value": "",
        "enums": []
        "validation": null,
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im choice-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes (hier keine Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier keine Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "choice" belegt
 * maxItems      - Maximale Anzahl an auswählbaren Werten/Zeichen
 * visibleItems  - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktuelle Auswahl die in der linken Liste angezeigt werden
 * enums         - Alle Auswahlmöglichkeiten
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * validationState   - Zustand der Validierung (hier ohne Bedeutung)
 * validationMessage - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as appActions from "../../../../store/actions/appActions";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-material.css'


class Choice extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.gridSelectedApi = null;
        this.gridSelectedColumnApi = null;

        this.gridChoiceApi = null;
        this.gridChoiceColumnApi = null;

        this.maxItems = -1;
        this.visibleItems = 5;

        this.rowHeight = 40;
        this.headerHeight = this.rowHeight;
    }

    /*==========================================================================
     *
     * RENDER - SECTION
     *
     *==========================================================================*/
    render() {
        if (this.debug) console.log("SelectWidget:render()")

        if (this.props.field.hasOwnProperty('maxItems')) {
            this.maxItems = this.props.field.maxItems;
        }

        if (this.props.field.hasOwnProperty('visibleItems')) {
            this.visibleItems = this.props.field.visibleItems;
        }

        const columnsDefsSelected = [
            {
                headerName: "Selected " + this.props.field.label,
                field: "label_all",
                width: (window.innerWidth / 2) / 5 * 2 - 50,
                checkboxSelection: false,
                suppressMenu: true,
                rowDrag: true
            },
        ];

        const columnsDefsChoice = [
            {
                headerName: "All " + this.props.field.label,
                field: "label_all",
                width: (window.innerWidth / 2) / 5 * 2 - 50,
                checkboxSelection: false,
                suppressMenu: true
            },
        ];

        // Column Definitions
        const defaultColDef = {
            sortable: false,
            editable: false,
            filter: false,
            resizable: false
        };

        const onGridSelectedReady = (params) => {
            if (this.debug) console.log('SelectWidget:onGridReady()', this.props.value);

            this.gridSelectedApi = params.api;
            this.gridSelectedColumnApi = params.columnApi;
        };

        const onGridChoiceReady = (params) => {
            if (this.debug) console.log('SelectWidget:onGridReady()', this.props.value);

            this.gridChoiceApi = params.api;
            this.gridChoiceColumnApi = params.columnApi;
        };

        const onRowSelectedAdd = (event) => {
            let selected = this.props.value;

            if (this.maxItems !== null && this.maxItems > 0) {
                if (selected.length >= this.maxItems) return;
            }

            selected.push(event.node.data.id)

            this.props.onSelect(selected);
        };

        const onRowSelectedDel = (event) => {
            let selected = this.props.value.filter((id) => id !== event.node.data.id);

            this.props.onSelect(selected);
        };

        const onRowDragEnd = () => {

            let selected = [];
            this.gridSelectedApi.forEachNode(function (node, index) {
                selected.push(node.data.id)
            });
            this.props.onSelect(selected);
        };

        let rowDataChoice = [];
        let rowDataSelected = [];

        let selected = this.props.value;

        this.props.field.enums.forEach(function (row) {
            if (row.id === 'placeholder') {
                rowDataSelected.push(row);
                rowDataChoice.push(row);
            } else {
                (selected.includes(row.id)) ? rowDataSelected.push(row) : rowDataChoice.push(row);
            }
        });

        let rowDataSelected2 = [];
        for (let i = 0; i < selected.length; i++) {
            for (let j = 0; j < rowDataSelected.length; j++) {
                if (rowDataSelected[j].id === selected[i]) {
                    rowDataSelected2.push(rowDataSelected[j])
                }
            }
        }

        // calculate height
        let height = this.visibleItems * this.rowHeight + this.headerHeight + 1;

        return (
            <div className="w-full flex " style={{ height: height + 'px' }}>
                <div className="w-2/5 ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridSelected"
                        onGridReady={onGridSelectedReady}

                        // Column
                        columnDefs={columnsDefsSelected}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={rowDataSelected2}
                        rowHeight={this.rowHeight}
                        rowSelection={"multiple"}
                        rowMultiSelectWithClick={true}
                        onRowSelected={onRowSelectedDel}
                        onRowDragEnd={onRowDragEnd}
                        rowDragManaged={true}

                        // Header
                        headerHeight={this.headerHeight}
                    />
                </div>
                <div className="w-1/5"></div>
                <div className="w-2/5 ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridChoice"
                        onGridReady={onGridChoiceReady}

                        // Column
                        columnDefs={columnsDefsChoice}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={rowDataChoice}
                        rowHeight={this.rowHeight}
                        rowSelection={"multiple"}
                        rowMultiSelectWithClick={true}
                        onRowSelected={onRowSelectedAdd}

                        // Header
                        headerHeight={this.headerHeight}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Choice);